export const CONSUMER_BASE_URL = 'https://support.office.live.com';
export const BUSINESS_BASE_URL = 'https://support.office.com';
export const HELP_LIGHT_THEME_ID = '6';
export const HELP_DARK_THEME_ID = '4';

export const APP_CONFIGS = {
    Owa: {
        NS: 'OLWAO365B',
        Version: '16',
    },
    OwaConsumer: {
        NS: 'OLWAC',
        Version: '16',
    },
    Monarch: {
        NS: 'NWOUTWIN',
        Version: '90',
    },
} as const;
